import React, { FC } from "react";
import { useParams } from "react-router-dom";
import { Checkbox, TableCell, Typography } from "@mui/material";
import { IChannel, ISelection, ISubChannel } from "../helper";
import { IVideo } from "../../../admin/videos/hooks/useFetchVideos";

interface Props {
  subChannel: ISubChannel;
  isChecked?: boolean;
  video: IVideo;
  group: any;
  channel: IChannel;
  selections: Array<ISelection>;
  setSelections: (data: Array<any>) => void;
}

export const CheckboxIcon: FC<Props> = (props) => {
  const { projectId } = useParams();
  const {
    subChannel,
    isChecked,
    group,
    selections,
    video,
    setSelections,
    channel,
  } = props;

  const handleClick = async (event: any, checked: boolean) => {
    const { value } = event.target;
    const newSelections = [...selections];
    const index = newSelections.findIndex(
      (e) => e.sub_channel_id === Number(value) && e.s3_file_id === video.id
    );
    console.log(index, value);
    if (index > -1) {
      newSelections[index].deactivated = !checked;
      newSelections[index].isDirty = true;
    } else {
      newSelections.push({
        project_id: Number(projectId),
        embed_id: group.id,
        s3_file_id: video.id,
        channel_id: channel.id,
        sub_channel_id: Number(value),
        deactivated: !checked,
        isDirty: true,
      });
    }
    setSelections(newSelections);
  };

  return (
    <TableCell component="th" scope="row" className="!flex gap-1 items-center">
      <Checkbox
        checked={isChecked}
        onChange={handleClick}
        value={subChannel.id}
      />
      <Typography variant="body1">{subChannel.name}</Typography>
    </TableCell>
  );
};
